import * as React from 'react';
import * as I18n from 'i18n-js';
import * as qs from 'qs';
import { PASSWORD_RESET_PATH } from '../url_helpers';
import bind from '../bind';
import CsrfForm from '../csrf_form';

import FormGroupWithCheckbox from './form_group_with_checkbox';
import FormGroupWithInput from './form_group_with_input';
import FacebookSignin from './facebook_signin';

interface Props {
  onToggle: { (event: any): void };
  redirectTo?: string;
  shouldRenderHeader?: boolean;
}

export default class SigninForm extends React.Component<Props, null> {
  static defaultProps: Partial<Props> = {
    shouldRenderHeader: true,
  };

  rememberMe = null;

  @bind
  handleSubmit(e) {
    const rememberMeElem = e.target.elements['user_session[remember_me]'];

    // Since we're using standard HTML form submit, we need to coerce
    // the react internal representation into standard booleans
    rememberMeElem.value = this.rememberMe.checked;
  }

  authUrlParams() {
    return qs.stringify({
      redirect_to: this.props.redirectTo,
    });
  }

  renderHeader() {
    if (!this.props.shouldRenderHeader) { return null; }

    return (
      <h4 className="signup-signin__header">
        {I18n.t('commons.signupForm.signinHeader')}
      </h4>
    );
  }

  render() {
    return (
      <div>
        {this.renderHeader()}
        <CsrfForm
          action={`/authenticate?${this.authUrlParams()}`}
          method="post"
          onSubmit={this.handleSubmit}
          data-disable-auto-validation="true" // block forms.js handling
        >
          <FormGroupWithInput
            label={I18n.t('commons.signupForm.emailLabel')}
            inputName="user_session[login]"
            inputType="email"
            autoComplete="email"
            autoFocus
            required
          />
          <FormGroupWithInput
            label={I18n.t('commons.signupForm.passwordLabel')}
            inputType="password"
            inputName="user_session[password]"
            required
            autoComplete="current-password"
          />

          <div className="scaling-mtb-2">
            <input type="submit"
              value={I18n.t('commons.signupForm.logIn')}
              className="button button--orange width-100"
            />
          </div>

          <FormGroupWithCheckbox
            label={I18n.t('commons.signupForm.rememberMe')}
            inputName="user_session[remember_me]"
            ref={r => this.rememberMe = r}
            defaultChecked
          />

          <p className="size-90 mt-1 align-center">
            {I18n.t('commons.signupForm.forgotPassword')}
            {' '}
            <a
              href={PASSWORD_RESET_PATH}
              target="_blank"
              rel="noopener noreferrer"
            >
              {I18n.t('commons.signupForm.passwordReset')}
            </a>
          </p>

          <hr className="mtb-2" />

          <div className="signup-signin__form__facebook">
            <FacebookSignin redirectTo={this.props.redirectTo} />
          </div>
        </CsrfForm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/signin_form.tsx